import React, {useContext} from 'react';
import {findMatchingProductFromProductId} from '../HelperFunctions';
import {BridleContext} from './../BridleContextProvider';

const Subtotal = () => {
    const {options, products} = useContext(BridleContext);
    const bridlePieces = Object.assign({}, options);
    delete bridlePieces['Color'];

    const prices = Object.values(bridlePieces)
        .map(value => value.productId)
        .map(id => findMatchingProductFromProductId(id, products))
        .filter(product => product !== undefined)
        .map(product => +product.price.current);

    const sum = (a, b) => a + b;
    const total = prices.reduce(sum, 0);
    const totalPrice = total > 0 ? total.toFixed(2) : '';
    const numOfItems = prices.length;

    return (
        <div className="bridle-subtotal-container grid-layout">
            {totalPrice && (
                <>
                    <span className="width-8/12"></span>
                    <span className="width-4/12 subtotal-bar">
                        Subtotal ({numOfItems} item{numOfItems > 1 ? 's' : ''}){': '}
                        <span className="subtotal-price">${totalPrice}</span>
                    </span>
                </>
            )}
        </div>
    );
};

export default Subtotal;
